import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import roomVideo from '../assets/Rooms/WhatsApp Video 2024-08-10 at 21.36.14.mp4'; // Import your video file here
import image1 from '../assets/Rooms/DSC_6136.JPG'; // Replace with your actual image paths
import image2 from '../assets/Rooms/DSC_6190.JPG'; // Replace with your actual image paths

function Rooms() {
    const descriptionParagraphs = [
        'At Hotel Bougainvilla, we offer an exquisite selection of rooms designed to provide the ultimate in comfort and luxury. Each room is a serene retreat, blending modern amenities with elegant decor that reflects the charm of our natural surroundings. Whether you’re here for a romantic getaway, a family vacation, or a business trip, our rooms cater to all your needs with plush bedding, spacious layouts, and stunning views of the garden or the cityscape.',
        'Enjoy a restful night’s sleep in our carefully curated spaces, each equipped with high-speed Wi-Fi, flat-screen TVs, and a well-appointed en-suite bathroom. Our attention to detail ensures that every aspect of your stay is infused with warmth and hospitality, making your experience at Hotel Bougainvilla truly memorable.',
        'From our cozy Standard Rooms to our luxurious Suites, discover the perfect accommodation that suits your style and preferences. Indulge in the elegance of Hotel Bougainvilla and let us be your home away from home.',
        'In addition to our in-room features, Hotel Bougainvilla offers personalized services to ensure your stay is seamless. Our dedicated staff is always on hand to cater to your requests, whether it’s arranging transportation, setting up a romantic dinner in your room, or assisting with special requirements.',
    ];

    const rateColumns = [
        'PRICE PER PERSON for 1 person occupancy',
        'PRICE PER PERSON for 2 people occupancy',
        'PRICE PER PERSON for 3 people occupancy',
    ];

    const rateTables = [
        {
            title: 'BOUGAINVILLA PRICE LIST till December 30th 2024 - 01 April 2025',
            image: image1,
            rows: [
                ['STANDARD DOUBLE ROOM with breakfast', '65 USD', '75 USD', '85 USD'],
                ['STANDARD DOUBLE ROOM with breakfast & dinner', '75 USD', '85 USD', '95 USD'],
                ['LUXURY DOUBLE ROOM with breakfast', '70 USD', '80 USD', '90 USD'],
                ['LUXURY DOUBLE ROOM with breakfast and dinner', '80 USD', '90 USD', '100 USD'],
            ],
        },
        {
            title: 'BOUGAINVILLA PRICE LIST till November 30, 2024',
            image: image2,
            rows: [
                ['STANDARD DOUBLE ROOM with breakfast', '55 USD', '65 USD', '75 USD'],
                ['STANDARD DOUBLE ROOM with breakfast & dinner', '63 USD', '71 USD', '85 USD'],
                ['LUXURY DOUBLE ROOM with breakfast', '60 USD', '67 USD', '80 USD'],
                ['LUXURY DOUBLE ROOM with breakfast and dinner', '67 USD', '75 USD', '90 USD'],
            ],
        },
    ];

    const renderRateTable = (table, index) => (
        <div key={index} className="overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm">
            <div className="overflow-x-auto">
                <table className="min-w-[680px] w-full border-collapse text-sm text-stone-700">
                    <tbody>
                        <tr className="bg-amber-100">
                            <td rowSpan={2} className="border border-stone-200 p-2 align-middle">
                                <img src={table.image} alt="Bougainvilla" className="h-20 w-28 rounded-md object-cover" />
                            </td>
                            <td colSpan={3} className="border border-stone-200 p-3 text-center text-sm font-semibold md:text-base">
                                {table.title}
                            </td>
                        </tr>
                        <tr className="bg-stone-50">
                            {rateColumns.map((column, columnIndex) => (
                                <td key={columnIndex} className="border border-stone-200 p-3 text-center text-xs font-medium md:text-sm">
                                    {column}
                                </td>
                            ))}
                        </tr>
                        {table.rows.map((row, rowIndex) => (
                            <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-stone-50/70'}>
                                {row.map((cell, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        className={`border border-stone-200 p-3 ${cellIndex === 0 ? 'font-medium' : 'text-center font-semibold text-amber-700'}`}
                                    >
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    return (
        <>
            <section className="relative min-h-[clamp(480px,88vh,760px)] overflow-hidden">
                <video className="absolute inset-0 h-full w-full object-cover" autoPlay loop muted playsInline>
                    <source src={roomVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/35" />
                <Navbar />

                <div className="relative z-10 container flex min-h-[clamp(480px,88vh,760px)] items-end pb-10 pt-28 sm:items-center sm:pb-12">
                    <div className="w-full max-w-2xl rounded-2xl border border-white/20 bg-black/25 p-5 backdrop-blur-sm sm:p-8">
                        <h1 className="text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl">
                            Discover the Perfect Room for Every Stay
                        </h1>
                        <p className="mt-4 text-sm leading-7 text-stone-200 sm:text-base">
                            At Hotel Bougainvilla, our rooms offer a blend of comfort and elegance, designed to cater to your every need.
                            Whether you’re seeking luxury, tranquility, or a cozy retreat, we have the perfect space to enhance your stay.
                        </p>
                        <Link
                            to="/contact-us"
                            className="mt-6 inline-flex w-full items-center justify-center rounded-lg bg-amber-600 px-5 py-3 text-sm font-semibold tracking-wide text-white transition hover:bg-amber-500 sm:w-auto"
                        >
                            CONTACT US
                        </Link>
                    </div>
                </div>
            </section>

            <section className="container py-8 sm:py-12">
                <h1 className="text-center text-3xl font-bold tracking-tight text-stone-700 sm:text-4xl lg:text-5xl">BOUGAINVILLA</h1>
                <nav className="mt-6 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
                    <Link
                        to="rooms-list"
                        className="rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-700 transition hover:border-amber-500 hover:text-amber-700"
                    >
                        Rooms List
                    </Link>
                    <Link
                        to="services"
                        className="rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-700 transition hover:border-amber-500 hover:text-amber-700"
                    >
                        Services
                    </Link>
                </nav>

                <div className="mt-8 overflow-hidden rounded-2xl border border-stone-200 bg-white p-3 shadow-sm sm:p-6">
                    <Outlet />
                </div>

                <div className="mt-10 grid items-start gap-6 lg:grid-cols-2">
                    <div className="space-y-4 rounded-2xl border border-stone-200 bg-white p-5 text-sm leading-7 text-stone-600 shadow-sm sm:p-6 sm:text-base sm:leading-8">
                        {descriptionParagraphs.map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                    </div>

                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-1">
                        <img src={image1} alt="Room view 1" className="h-64 w-full rounded-2xl object-cover shadow-sm sm:h-72" />
                        <img src={image2} alt="Room view 2" className="h-64 w-full rounded-2xl object-cover shadow-sm sm:h-72" />
                    </div>
                </div>
            </section>

            <section className="bg-stone-100 py-10 sm:py-12">
                <div className="container">
                    <h2 className="text-center text-2xl font-bold tracking-tight text-stone-700 sm:text-3xl lg:text-4xl">
                        Our Current Room Rates
                    </h2>
                    <div className="mt-8 grid gap-5 xl:grid-cols-2">
                        {rateTables.map((table, index) => renderRateTable(table, index))}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default Rooms;
